<h1 mat-dialog-title>{{ data?.honorar ? 'Honorar-Artikel suchen' : 'Nebenkosten-Artikel suchen' }}</h1>
<div mat-dialog-content class="picker-content">
    <p class="hint" *ngIf="!data?.honorar">
        Suche nach Bezeichnung, Kürzel, Konto-ID oder Tags. Tags dienen nur der Suche und werden nicht angezeigt.
    </p>
    <p class="hint" *ngIf="data?.honorar">
        Suche nach Bezeichnung, Kürzel oder Konto (z.B. 4780). Neu anlegen mit Recht 1001 möglich.
    </p>

    <mat-form-field appearance="outline" class="full search-field">
        <mat-label>Suche</mat-label>
        <input matInput [formControl]="searchCtrl" placeholder="z.B. Workwear, 4810, Diesel …" autofocus />
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div class="toolbar">
        <span class="result-meta" *ngIf="!loading && (searchCtrl.value || '').trim()">
            {{ results.length }} Treffer
        </span>
        <span class="spacer"></span>
        <button
            *ngIf="canCreate"
            mat-stroked-button
            type="button"
            color="accent"
            (click)="toggleCreate()"
        >
            <mat-icon>{{ showCreate ? 'close' : 'add' }}</mat-icon>
            {{ showCreate ? 'Anlegen abbrechen' : 'Neu anlegen' }}
        </button>
    </div>

    <div class="create-panel" *ngIf="canCreate && showCreate">
        <mat-form-field appearance="outline" class="full">
            <mat-label>Bezeichnung</mat-label>
            <input matInput [formControl]="bezeichnungCtrl" required />
        </mat-form-field>
        <mat-form-field appearance="outline" class="full">
            <mat-label>Kürzel</mat-label>
            <input matInput [formControl]="kuerzelCtrl" />
            <mat-hint>Optional – sonst aus Bezeichnung</mat-hint>
        </mat-form-field>
        <div class="row">
            <mat-form-field appearance="outline" class="half">
                <mat-label>Buchungskonto (Sachkonto)</mat-label>
                <input
                    matInput
                    [formControl]="buchungskontoCtrl"
                    required
                    placeholder="z.B. 4930"
                    [matAutocomplete]="autoBuchung"
                />
                <mat-autocomplete #autoBuchung="matAutocomplete">
                    <mat-option *ngFor="let opt of buchungskontoOptions" [value]="opt.konto_nr">
                        <span class="konto-nr">{{ opt.konto_nr }}</span>
                        <span class="konto-bez">{{ opt.bezeichnung }}</span>
                    </mat-option>
                </mat-autocomplete>
                <mat-hint>Aufwandskonto aus dem Kontenrahmen</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline" class="half">
                <mat-label>Gegenkonto</mat-label>
                <input
                    matInput
                    [formControl]="buchungsgegenkontoCtrl"
                    placeholder="z.B. 1600"
                    [matAutocomplete]="autoGegen"
                />
                <mat-autocomplete #autoGegen="matAutocomplete">
                    <mat-option *ngFor="let opt of gegenkontoOptions" [value]="opt.konto_nr">
                        <span class="konto-nr">{{ opt.konto_nr }}</span>
                        <span class="konto-bez">{{ opt.bezeichnung }}</span>
                    </mat-option>
                </mat-autocomplete>
                <mat-hint>Default 1600</mat-hint>
            </mat-form-field>
        </div>
        <div class="create-actions">
            <button
                mat-flat-button
                color="accent"
                type="button"
                [disabled]="!isCreateValid() || creating"
                (click)="create()"
            >
                Anlegen und übernehmen
            </button>
        </div>
    </div>

    <div class="loading" *ngIf="loading">Suche …</div>
    <div class="empty" *ngIf="!loading && !(searchCtrl.value || '').trim() && !showCreate">
        Tippe einen Suchbegriff ein.
    </div>
    <div class="empty" *ngIf="!loading && (searchCtrl.value || '').trim() && results.length === 0 && !showCreate">
        Keine Treffer – ggf. neu anlegen.
    </div>

    <div class="result-list" *ngIf="!loading && results.length">
        <button
            type="button"
            class="result-row"
            *ngFor="let row of results"
            (click)="select(row)"
        >
            <span class="bez">{{ row.bezeichnung }}</span>
            <span class="meta">
                <span *ngIf="row.kuerzel" class="kuerzel">{{ row.kuerzel }}</span>
                <span class="konto">{{ row.buchungskonto || '–' }}</span>
            </span>
        </button>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Abbrechen</button>
</div>
